angular
	.module('servicepro.analysis.hours')
	.controller('HoursController', [
		'$log',
		'$scope',
		'$rootScope',
		'$filter',
		'$resource',
		'$timeout',
		'gettextCatalog',
		'apiURLs',
		'$http',
		'$compile',
		'lineChartOptions',

		function HoursControllerFactory($log, $scope, $rootScope, $filter, $resource, $timeout, gettextCatalog, apiURLs, $http, $compile, lineChartOptions) {
            $log.debug('HoursControllerFactory OK');

			var dateEndDt = moment(),
				dateStartDt = moment(dateEndDt).subtract(1, 'weeks'),
				linesChart;

			$scope.state = {
				init: true,
				loading: true,
				filters: { // API filters
					daterange: {
						start: dateStartDt.format('YYYY-MM-DD'), // 'YYYY-MM-DD'
						end: dateEndDt.format('YYYY-MM-DD') // 'YYYY-MM-DD'
					}
				}
			};

			$scope.drawLinesChart = function(requestsData) {
                $("#hours-total-planned").html(requestsData.totals.planned);
                $("#hours-average-planned").html(requestsData.totals.avg_daily_planned + " %");
                $("#hours-total-worked").html(requestsData.totals.worked);
                $("#hours-average-worked").html(requestsData.totals.avg_daily_worked + " %");

                var colorLines = {
                    planned: '#1ba4d3', // Light Blue
                    worked: '#6ec563', // Green
                };

                var labelsDates = requestsData.per_dates.labels;
                var labels = [];
                var months = [];
                labelsDates.forEach(function(part, index) {
                    labels[index] = new Date(part).getDate();
                    months[index] = new Date(part).getMonthName();
                });
                months = Array.from(new Set(months)).join(' / ');

                var dataSet = [];
                for(var item in requestsData.per_dates.counts) {
                    var data = {
                        borderColor: colorLines[item],
                        pointBorderColor: colorLines[item],
                        data: requestsData.per_dates.counts[item]
                    };
                    dataSet.push(data);
                }

                linesChart = new Chart($("#hours-line-chart"), {
                    type: 'line',
                    data: {
                        labels: labels,
                        datasets: dataSet,
                    },
                    options: lineChartOptions(months, "Hs")
                });
			};

			// API opts based on state
			$scope.getApiOptions = function(overrides) {
				var options = {};
				// API filters
				if ($scope.state.filters.daterange) {
					options.date_from = $scope.state.filters.daterange.start;
					options.date_to = $scope.state.filters.daterange.end;
				}
				// Apply overrides
				angular.extend(options, overrides);
				return options;
			};

			// Draw charts
			$scope.draw = function() {
                $resource(apiURLs.analysis.hours).query(
			        $scope.getApiOptions(),
					function(requestsData) {
						$scope.drawLinesChart(requestsData);
					}, function(requestsData) {
						$log.error("Hours Data. FAILED");
					}
				);
			};

			// Watch for filters
			// Daterange: fetch from API
			$scope.$watchCollection('state.filters.daterange', function(nv, ov) {
				if (!$scope.state.init) {
					$scope.draw();
				}
			});

			// Init
			$scope.init = function() {
				$scope.state.init = false;
			};
			// Init
			$scope.init();
        }
    ]);